(() => {
  const config = document.getElementById('rg-rivo-locale');
  const sources = window.rgRivoLocaleSources;
  if (!config || !sources) return;
  const locale = document.documentElement.lang.split('-')[0];
  if (!['es', 'en'].includes(locale)) return;
  const targets = JSON.parse(config.textContent);
  const exact = new Map();
  const patterns = [];
  const escape = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const clean = text => text.trim().replace(/\s+/g, ' ');
  for (const [key, variants] of Object.entries(sources)) {
    for (const source of variants) {
      const target = targets[key];
      if (!source || !target) continue;
      const names = [...source.matchAll(/\{\{\s*(\w+)\s*\}\}/g)].map(match => match[1]);
      if (!names.length) exact.set(clean(source), target);
      else {
        const pieces = source.split(/\{\{\s*\w+\s*\}\}/g);
        patterns.push({regex: new RegExp('^' + pieces.map(escape).join('(.+?)') + '$'), names, target});
      }
    }
  }
  const translate = text => {
    const value = clean(text);
    if (exact.has(value)) return text.replace(text.trim(), exact.get(value));
    for (const {regex, names, target} of patterns) {
      const match = value.match(regex);
      if (match) {
        let result = target;
        names.forEach((name, index) => { result = result.replaceAll('__RG_' + name + '__', match[index + 1]); });
        return text.replace(text.trim(), result);
      }
    }
    if (locale === 'es') {
      const points = value.match(/^([\d,]+)\s+(Points|Point|points|point)$/);
      if (points) return text.replace(text.trim(), Number(points[1].replaceAll(',', '')).toLocaleString('es-ES') + ' ' + targets[points[2].toLowerCase() === 'point' ? 'general_point' : 'general_points']);
    }
    return text;
  };
  const skip = 'script,style,noscript,textarea,input,code,pre,[contenteditable="true"]';
  function translateText(node) {
    if (!node.parentElement || node.parentElement.closest(skip)) return;
    const next = translate(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }
  function walk(root) {
    if (root.nodeType === 3) return translateText(root);
    if (root.nodeType !== 1 || root.matches(skip)) return;
    const walker = root.ownerDocument.createTreeWalker(root, 4);
    let node;
    while ((node = walker.nextNode())) translateText(node);
    for (const element of [root, ...root.querySelectorAll('[aria-label],[placeholder],[title]')]) {
      if (element.matches(skip) && element.tagName !== 'INPUT') continue;
      for (const attribute of ['aria-label', 'placeholder', 'title']) {
        const value = element.getAttribute(attribute);
        if (value) {
          const next = translate(value);
          if (next !== value) element.setAttribute(attribute, next);
        }
      }
    }
  }
  const attached = new WeakSet();
  const documents = new WeakSet();
  function attach(frame) {
    const observe = () => {
      let doc;
      try { doc = frame.contentDocument; } catch { return; }
      if (!doc || documents.has(doc)) return;
      documents.add(doc);
      const options = {subtree:true, childList:true, characterData:true};
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        setTimeout(() => {
          observer.disconnect();
          if (doc.body) walk(doc.body);
          observer.observe(doc, options);
          scheduled = false;
        }, 50);
      });
      if (doc.body) walk(doc.body);
      observer.observe(doc, options);
    };
    if (!attached.has(frame)) {
      attached.add(frame);
      frame.addEventListener('load', observe);
    }
    observe();
  }
  const discover = () => {
    const frame = document.getElementById('ba-other-window-body');
    if (frame?.tagName === 'IFRAME') attach(frame);
  };
  discover();
  let discovering = false;
  new MutationObserver(() => {
    if (discovering) return;
    discovering = true;
    setTimeout(() => { discover(); discovering = false; }, 50);
  }).observe(document.body, {childList:true, subtree:true});
})();
